


















































































































































































































































































































































































































import ContractSideCard from "@/components/contract/ContractSideCard.vue";
import VehicleContractSideCard from "@/components/fleet/VehicleContractSideCard.vue";
import PartnerReportVehicleSuggestionMixin from "@/components/partner/report/v2/vehicle/PartnerReportVehicleSuggestionMixin.vue";
import AEicon from "@/components/utility/AEicon.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import GeoFinderField from "@/components/utility/GeoFinderField.vue";
import MIconButton from "@/components/utility/mmmint/MIconButton.vue";
import MNoContent from "@/components/utility/mmmint/MNoContent.vue";
import MSelect from "@/components/utility/mmmint/MSelect.vue";
import MTextField from "@/components/utility/mmmint/MTextField.vue";
import TableWrapper, { ITableWrapperHeader } from "@/components/utility/TableWrapper.vue";
import VehicleApiSelection from "@/components/utility/VehicleApiSelection.vue";
import { ActivityTypeEnum } from "@/lib/enum/activity-type.enum";
import { VehicleOwnershipStatusEnum } from "@/lib/enum/vehicle-ownership-status.enum";
import { VehicleTabs } from "@/lib/enum/vehicle-tabs.enum";
import { VehicleStateEnum } from "@/lib/enum/vehicleState.enum";
import { GoToHelper } from "@/lib/utility/goToHelper";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { ActivityLog } from "@/models/activity-log.entity";
import { AddressWithGeoBase, IAddressWithGeo } from "@/models/address.entity";
import { IContract } from "@/models/contract.entity";
import { VehicleContractType } from "@/models/types/vehicle-contract-type";
import { VehicleContractBase } from "@/models/vehicle-contract-base.entity";
import { VehicleRegistration } from "@/models/vehicle-registration.entity";
import { IVehicle, Vehicle } from "@/models/vehicle.entity";
import {
  MrfiktivCreateActivityLogDtoGen,
  MrfiktivCreateVehicleDtoGen,
  MrfiktivCreateVehicleRegistrationDtoGen,
  MrfiktivVehicleInsuranceContractViewModelGen,
  MrfiktivVehicleLeasingContractViewModelGen
} from "@/services/mrfiktiv/v1/data-contracts";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { PartnerModule } from "@/store/modules/partner";
import { VehicleModule } from "@/store/modules/vehicle.store";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import PartnerReportMapAddress from "./PartnerReportMapAddress.vue";
import PartnerReportVehicleFleetDocumentTable from "@/components/partner/report/v2/vehicle/PartnerReportVehicleFleetDocumentTable.vue";
import TabLayout from "@/layouts/TabLayout.vue";
import { $t } from "@/lib/utility/t";

@Component({
  components: {
    MIconButton,
    MNoContent,
    MSelect,
    MTextField,
    AEicon,
    TableWrapper,
    VehicleContractSideCard,
    ContractSideCard,
    ConfirmActionDialog,
    VehicleApiSelection,
    PartnerReportMapAddress,
    GeoFinderField,
    PartnerReportVehicleFleetDocumentTable,
    TabLayout
  },
  filters: {}
})
class PartnerReportDetailVehicle extends mixins(PermissionMixin, PartnerReportVehicleSuggestionMixin) {
  readonly = true;

  vehicleSideCardContract: VehicleContractType | null = null;
  fleetSideCardContract: IContract | null = null;
  isAssociatedDialogOpen = false;
  loadingUpdate = false;
  selectedVehicleIndex: number | null = null;
  isSelectionMade = false;
  selected: IVehicle | null = null;
  isFleetDescriptionMenu = false;

  isLocationDialogOpen = false;
  isLocationLoading = false;
  isLocationValid = false;
  location: IAddressWithGeo | null = new AddressWithGeoBase(this.report.accidentDetails?.address);

  fleetTab = 0;

  get fleetTabs() {
    const tabs = [];

    if (this.vehicle)
      tabs.push({
        id: 0,
        value: $t("report.fleet.vehicleContracts")
      });

    tabs.push({
      id: 1,
      value: $t("report.fleet.contracts")
    });

    tabs.push({
      id: 2,
      value: $t("report.fleet.fleetDocuments")
    });

    return tabs;
  }

  get isFleetLoading() {
    return (
      this.report?.isFleetLoading || this.report?.fleet?.isLoadingContracts || this.report.fleet?._isLoadingCompany
    );
  }

  get isAssociatedValid() {
    return this.isSelected || this.isSuggestedClicked;
  }

  get isSuggestedClicked() {
    return this.selectedVehicleIndex !== undefined && this.selectedVehicleIndex !== null;
  }

  get isSelected() {
    return Boolean(this.selected);
  }

  get partner() {
    return PartnerModule.partner;
  }

  get report() {
    return PartnerModule.report;
  }

  get vehicle() {
    return PartnerModule.report.vehicle;
  }

  get vehicleStates() {
    return Object.values(VehicleStateEnum);
  }

  get ownershipTypes() {
    return Object.values(VehicleOwnershipStatusEnum);
  }

  get ownershipItems() {
    return Object.values(VehicleOwnershipStatusEnum).map(value => ({
      value,
      text: this.$t(`enums.VehicleOwnershipStatusEnum.${value}`)
    }));
  }

  get vehicleStatusItems() {
    return Object.values(VehicleStateEnum).map(value => ({
      value,
      text: this.$t(`enums.VehicleStateEnum.${value}`)
    }));
  }

  get statusColor() {
    const state = this?.vehicle?.state;
    if (!state) return "Grey";

    return VehicleModule.stateMap.get(state)?.color || "Grey";
  }

  get headersVehicleContract(): ITableWrapperHeader[] {
    return [
      {
        text: "",
        value: "isActive",
        width: "50px"
      },
      {
        text: this.$t("components.fleet.FleetVehicleDetailContractTable.title").toString(),
        value: "title"
      },
      {
        text: this.$t("components.fleet.FleetVehicleDetailContractTable.contractType").toString(),
        value: "contractType",
        width: "150px"
      },
      {
        text: this.$t("components.fleet.FleetVehicleDetailContractTable.number").toString(),
        value: "number",
        width: "150px"
      },
      {
        text: this.$t("components.fleet.FleetVehicleDetailContractTable.startDate").toString(),
        value: "startDate",
        width: "150px",
        type: "date"
      },
      {
        text: this.$t("components.fleet.FleetVehicleDetailContractTable.endDate").toString(),
        value: "endDate",
        width: "150px",
        type: "date"
      }
    ];
  }

  get headersFleetContract(): ITableWrapperHeader[] {
    return [
      {
        text: "",
        value: "isActive",
        width: "50px"
      },
      {
        text: this.$t("common.nouns.title").toString(),
        value: "title"
      },
      {
        text: this.$t("objects.contract.type").toString(),
        value: "type",
        width: "150px"
      },
      {
        text: this.$t("components.fleet.FleetVehicleDetailContractTable.number").toString(),
        value: "number",
        width: "150px"
      },
      {
        text: this.$t("components.fleet.FleetVehicleDetailContractTable.startDate").toString(),
        value: "startDate",
        width: "150px",
        type: "date"
      },
      {
        text: this.$t("components.fleet.FleetVehicleDetailContractTable.endDate").toString(),
        value: "endDate",
        width: "150px",
        type: "date"
      }
    ];
  }

  async mounted() {
    if (!this.report.vehicleId) {
      this.$log.debug("No vehicle");
      this.loadingUpdate = true;
      try {
        await this.lookupVehicleSuggestions(this.report);
      } catch (error) {
        handleError(error);
      } finally {
        this.loadingUpdate = false;
      }
    }
  }

  editLocation() {
    this.location = new AddressWithGeoBase(this.report.location);
    this.isLocationDialogOpen = true;
  }

  select(selected?: IVehicle) {
    this.isSelectionMade = Boolean(selected);
    if (selected) {
      this.selectedVehicleIndex = null;
    }
    this.selected = selected ?? null;
  }

  isActiveVehicleContract(
    item: MrfiktivVehicleInsuranceContractViewModelGen | MrfiktivVehicleLeasingContractViewModelGen
  ): boolean {
    return new VehicleContractBase(item).activeContractAtDate(this.report.accidentDate);
  }

  openVehicleContractSideCard(contract: VehicleContractType | null) {
    if (!contract?.id) {
      return;
    }

    this.vehicleSideCardContract = null;
    this.$nextTick(() => {
      this.vehicleSideCardContract = contract;
    });
  }

  openFleetContractSideCard(contract: IContract) {
    if (!contract?.id) {
      return;
    }

    this.fleetSideCardContract = null;
    this.$nextTick(() => {
      this.fleetSideCardContract = contract;
    });
  }

  goToDetail() {
    this.goToVehicle(this.vehicle);
  }

  goToVehicle(vehicle: IVehicle | null) {
    if (!vehicle?.id) {
      return;
    }

    new GoToHelper(this.$router).goToVehicleDetail(vehicle.id, vehicle.partnerId, VehicleTabs.HOME, true);
  }

  goToFleet() {
    const fleetId = this.vehicle?.groupId;

    if (!fleetId) {
      return;
    }

    return this.$router.push({
      name: "FleetDetailView",
      params: { partnerId: this.partner.id, fleetId: fleetId }
    });
  }

  onGroupIdAction() {
    if (this.vehicle?.fleet?.description) {
      this.isFleetDescriptionMenu = true;
    } else {
      this.goToFleet();
    }
  }

  async addVehicle() {
    let vehicleId = undefined;
    if (this.isSelectionMade && this.selected) {
      vehicleId = this.selected.id;
    } else if (this.selectedVehicleIndex !== undefined && this.selectedVehicleIndex !== null) {
      vehicleId = this.vehicleSuggestions[this.selectedVehicleIndex].id;
    }

    if (!vehicleId) {
      return;
    }

    try {
      this.loadingUpdate = true;

      const vehicle = await new Vehicle({ id: vehicleId, partnerId: this.report.partnerId }).fetch();

      await this.report.addVehicle(vehicle);

      if (this.canReadCompany) {
        await this.report.fetchCompanies().catch(e => handleError(e));
      }
    } catch (error) {
      handleError(error);
    } finally {
      this.loadingUpdate = false;
    }
  }

  async removeVehicle() {
    try {
      this.loadingUpdate = true;

      await this.report.updatePartial({ vehicleId: null });
    } catch (error) {
      handleError(error);
    } finally {
      this.loadingUpdate = false;
    }
  }

  async createNewVehicle() {
    const partnerId = this.report.partnerId;
    try {
      const data: MrfiktivCreateVehicleDtoGen = {
        identificationnumber: this.report.registrationResults.identificationnumber,
        displayName: this.report.numberplate,
        state: VehicleStateEnum.PARTIAL,
        mileages: [],
        numberplate: this.report.numberplate,
        registration: new VehicleRegistration(
          this.report.registrationResults
        ) as MrfiktivCreateVehicleRegistrationDtoGen
      };

      this.loadingUpdate = true;

      const vehicle = await VehicleModule.create({ partnerId, data });

      this.report.vehicleId = vehicle.id;
      this.report.vehicle = vehicle;

      await this.report.updatePartial({ vehicleId: vehicle.id });

      const activity: MrfiktivCreateActivityLogDtoGen = {
        source: {
          refId: this.report.id,
          refType: BackendResourceEnum.REPORT
        },
        target: [
          {
            refType: BackendResourceEnum.VEHICLE,
            refId: vehicle.id
          }
        ],
        actionType: ActionEnum.CREATE,
        activity: ActivityTypeEnum.UPDATE_REPORT
      };

      await new ActivityLog({
        partnerId: this.report.partnerId,
        ...activity
      }).create();
    } catch (e) {
      handleError(e);
    } finally {
      this.loadingUpdate = false;
    }
  }

  async addLocation() {
    if (!this.location) {
      return;
    }
    try {
      this.isLocationLoading = true;

      const locationHistory = this.report.locationHistory || [];
      locationHistory.push({ ...this.location, at: new Date().toISOString() });

      await this.report.updatePartial({ location: this.location, locationHistory });

      this.isLocationDialogOpen = false;
    } catch (error) {
      handleError(error);
    } finally {
      this.isLocationLoading = false;
    }
  }

  async removeLocation() {
    try {
      this.isLocationLoading = true;
      await this.report.updatePartial({ location: null });

      this.isLocationDialogOpen = false;
    } catch (error) {
      handleError(error);
    } finally {
      this.isLocationLoading = false;
    }
  }
}

export default PartnerReportDetailVehicle;
